// Change your display name on tha landing display
const header = {
  name: 'James',
}
const background = {
  // Options: Snow or Particle
  type: 'Snow',
}
// Write a para about yourself here
// To update your image, go to './styles/images.css'
const about = {
  paragraph:
    'I am a Software Developer with many skills. My core skill set is with Next.js and TailwindCSS. I graduated from California Polytechnic State University at San Luis Obispo with a Bachelors Degree in Engineering Technology, I graduated in 1986. I am skilled developing performant websites with TailwindCSS, HTML, JSX, and Markdown for api and RESTful page display. I implement these websites and they have fast page display times from their pre-rendered to HTML for SEO efficiency. Next.js use of “Image” and “Link” commands in JSX give extra special magic for its rapid display flare. My talent and skills include HTML, CSS3, Bootstrap, Bulma, TailwindCSS, and W3CSS layout, my preference is Next.js with TailwindCSS for great mega-menus for graphical display fast write page performance.',
}
// Edit your skill and the percentage you know about it
// To Add a skill, copy any one below and paste it after the last comma
const skillsBar = [
  {
    name:
      'Recent Programming Skills, Optical Automation, 2019 - 2021, Next.js / TailwindCSS',
    value: 100,
  },

  {
    name: 'Next.js / TailwindCSS, Research and Development',
    value: 100,
  },
  {
    name: 'Next.js / TailwindCSS, "MyOneUniverse App Design and Production',
    value: 90,
  },
  {
    name: 'Next.js, Client Side Data Fetching, Static Generation',
    value: 90,
  },
  {
    name: 'Next.js, Server Side Rendering',
    value: 90,
  },
  {
    name: 'The Branded Series websites, Next.js, Wix',
    value: 90,
  },

  {
    name: 'Next.js Mongo DB Atlas / Mongoose',
    value: 65,
  },
  {
    name: 'Next.js Authentication, Auth0 / Firebase / nextAuth.js',
    value: 55,
  },
  {
    name: 'JavaScript MERN, MongoDB / Express.js / React.js / Node.js',
    value: 50,
  },

  {
    name: 'React Native, iOS / Andriod apps',
    value: 40,
  },

  {
    name: 'Bootstrap / CSS3 / W3CSS, Wix website development',
    value: 45,
  },
  {
    name:
      'Apple Xcode, Swift iOS / Xamarin C# iOS / Andriod apps / App Store Publishing',
    value: 40,
  },

  {
    name: 'Microsoft, Visual Studio, Community, Visual Studio Code',
    value: 40,
  },
  {
    name:
      'Apple MacOS, 2006 - 2021, Snow Leopard thur BigSir, MacMini, Laptops, Multiple monitor system',
    value: 30,
  },
  {
    name: 'More Technical Experiences, 1986 - 2013',
    value: 0,
  },

  {
    name:
      'AT & T, 2000 - 2013, National, Remote Circuit DS0 / T1 / DS3 Technical Repair, Maintenance Technical Support, 13 Years',
    value: 35,
  },
  {
    name:
      'AT & T, A+ Certified, DS0 Internet Field Provisioning, Wiindows, MacOS',
    value: 30,
  },
  {
    name:
      'Optical Automation, 1987 - 1992, Wrote and Drafted Mechanical and Flowchart, Two U.S. Utility Eyeglass Measuring System Patents ',
    value: 30,
  },
  {
    name:
      'Optical Automation, 1987 - 1992, Phase I Grant proposals, Nat Science Foundation, Nat Eye Foundation, Eye Measuring System, ',
    value: 30,
  },

  {
    name:
      'Microsoft DOS, 2.1, 2.2, 3.1, Windows  v1, v3, 95, 2000, NT, XP, 8, 10, Office, Word, PowerPoint, Excel',
    value: 30,
  },
  {
    name: 'C Language, Basic, Fortran, Pascal',
    value: 25,
  },
  {
    name:
      'Assembly Language, Intel SDK-8080, SDK-8086, Zilog Z80, Motorola 6502, Digitalker, HPIB-IEEE-488 ',
    value: 20,
  },
]
// Edit your projects, its name, your skills used to make it, and the url.
// You can omit freely anything if you dont have it
// To Add a Project, copy any one below and paste it after the last comma and increment the id's project number
const projects = [
  {
    // Add image in './styles/images.css' in #project1
    id: 'project1',
    name: 'Optical Automation, LLC',
    skills: ['Wix.com, Imaging'],
    url: 'http://www.OpticalAutomation.com',
  },
  {
    // Add image in './styles/images.css' in #project2
    id: 'project2',
    name: 'JamesAvakian.com',
    skills: [
      'Next.js, TailwindCSS, JSX, MarkDown MDX, GitHub, Vercel, Imaging',
    ],
    url: 'https://nextjs-tailwindcss-mdx-jamesavakian.vercel.app/likes',
  },
  {
    // Add image in './styles/images.css' in #project3
    id: 'project3',
    name: 'Good Day Music.com',
    skills: [
      'Next.js, TailwindCSS, JSX, MarkDown MDX, GitHub, Vercel deploy, Imaging',
    ],
    url: 'https://javakian1.wixsite.com/gooddaymusic ',
  },
  {
    // Add image in './styles/images.css' in #project4
    id: 'project4',
    name: 'eCommerce',
    skills: ['Wix.com, HouseOfWebs.com/eCommerce'],
    url: 'http://javakian1.wixsite.com/mysite-10',
  },
  {
    // Add image in './styles/images.css' in #project5
    id: 'project5',
    name: 'House Of Webs.com',
    skills: ['Wix.com'],
    url: 'http://www.HouseOfWebs.com',
  },
  {
    // Add image in './styles/images.css' in #project6
    id: 'project6',
    name: 'MyTechnologyHouse.com',
    skills: ['Wix.com'],
    url: 'http://www.technologyandtimes.com/',
  },
]
// Edit your Miscellaneous Activities, its name and the url.
// You can omit freely anything if you dont have it
// To Add a Activity, copy any one below and paste it after the last comma and increment the id's Miscellaneous number
const miscellaneous = [
  {
    // Add image in './styles/images.css' in #misc1
    id: 'misc1',
    name: 'Product Videos',
    url: 'https://vimeo.com/user108564543',
  },
  {
    // Add image in './styles/images.css' in #misc2
    id: 'misc2',
    name: 'The Importance of Next.js',
    url:
      'https://javakian1.wixsite.com/opticalautomation-c/copy-of-technology-1',
  },
  {
    // Add image in './styles/images.css' in #misc3
    id: 'misc3',
    name: 'Technical Documents',
    url: 'https://javakian1.wixsite.com/opticalautomation-c/copy-of-investors',
  },
]
// Contact form text, and Jotforms link
// To get your own jotform link, go to https://www.jotform.com/
// If you hacve the link already, paste it in the contactUrl below
const contact = {
  pitch:
    'Hello, If you have any questions or want to talk to me regarding any topic whether it be for a website or project please send me a message.',
  copyright: 'James Avakian',
  contactUrl: 'http://www.OpticalAutomation.com',
}
// Paste your respective social media links. You can omit any if you dont have it
// Upload your resume in your drive, get the shaareable link and paste it in the resume section
const social = {
  github: 'https://github.com/javakian',
  facebook: 'https://www.facebook.com/Optical-Automation-LLC-134475819954908',
  linkedin: 'https://www.linkedin.com/in/james-l-avakian-13500713/',
  instagram: 'https://www.pinterest.com/jamesavakian/',
  resume: 'https://optical.hosted-by-files.com/public/ResumeAug2021.pdf/',
}

// Dont change anything here
export {
  header,
  background,
  about,
  skillsBar,
  projects,
  miscellaneous,
  contact,
  social,
}
